import { render, staticRenderFns } from "./Waiyuzhonglei.vue?vue&type=template&id=580a6206&scoped=true&"
import script from "./Waiyuzhonglei.vue?vue&type=script&lang=js&"
export * from "./Waiyuzhonglei.vue?vue&type=script&lang=js&"
import style0 from "./Waiyuzhonglei.vue?vue&type=style&index=0&id=580a6206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a6206",
  null
  
)

export default component.exports